module.exports = __webpack_public_path__ + "50d75e48e0a3ddab1dd15d6bfb9d3700.woff";